module.exports = __webpack_public_path__ + "img/snake_control_up.1fcb1e64.svg";